/**
 * Created by JasonChou on 16/4/28.
 */
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import wx from './libs/wx'

export const router = new VueRouter();

router.map({

  topHome: {
    name: 'topHome',
    component(resolve) {
      require.ensure(['./components/topHome.vue'], function (require) {
        const component = require('./components/topHome.vue');
        resolve(component);
      }, 'topHome');
    }
  },

  home: {
    name: 'home',
    component(resolve) {
      require.ensure(['./components/homeTab.vue'], function (require) {
        const component = require('./components/homeTab.vue');
        resolve(component);
      }, 'home');
    }
  },


  search: {
    name: 'search',
    component(resolve) {
      require.ensure(['./components/search.vue'], function (require) {
        const component = require('./components/search.vue');
        resolve(component);
      }, 'search');
    }
  },

  homeWell: {
    name: 'homeWell',
    component(resolve) {
      require.ensure(['./components/home.vue'], function (require) {
        const component = require('./components/home.vue');
        resolve(component);
      }, 'homeWell');
    }
  },

  cate: {
    name: 'cate',
    component(resolve) {
      require.ensure(['./components/cate.vue'], function (require) {
        const component = require('./components/cate.vue');
        resolve(component);
      }, 'cate')
    }
  },
  'product/:spu_id/:sku_id': {
    name: 'product',
    title: '商品详情',
    customNav: true,
    component(resolve) {
      require.ensure(['./screens/ProductDetailScreen.vue'], function (require) {
        const component = require('./screens/ProductDetailScreen.vue');
        resolve(component);
      }, 'product')
    }
  },

  'comments/:spu_id': {
    name: 'comments',
    title: '热门评论',
    customNav: true,
    component(resolve) {
      require.ensure(['./screens/CommentsScreen.vue'], function (require) {
        const component = require('./screens/CommentsScreen.vue');
        resolve(component);
      }, 'comments')
    }
  },
  'order/confirm/:skus': {
    name: 'confirmOrder',
    title: '确认订单',
    component(resolve) {
      require.ensure(['./screens/ConfirmOrderScreen.vue'], function (require) {
        const component = require('./screens/ConfirmOrderScreen.vue');
        resolve(component);
      }, 'confirmOrder')
    }
  },
  'addresses/add': {
    name: 'addAddress',
    title: '添加收货地址',
    component(resolve) {
      require.ensure(['./screens/AddAddressScreen.vue'], function (require) {
        const component = require('./screens/AddAddressScreen.vue');
        resolve(component);
      }, 'addAddress')
    }
  },
  'addresses/add/first': {
    name: 'addFirstAddress',
    title: '添加收货地址',
    component(resolve) {
      require.ensure(['./screens/AddAddressScreen.vue'], function (require) {
        const component = require('./screens/AddAddressScreen.vue');
        resolve(component);
      }, 'addAddress')
    }
  },
  'addresses/edit/:address': {
    name: 'editAddress',
    title: '编辑收货地址',
    component(resolve) {
      require.ensure(['./screens/AddAddressScreen.vue'], function (require) {
        const component = require('./screens/AddAddressScreen.vue');
        resolve(component);
      }, 'addAddress')
    }
  },
  'addresses': {
    name: 'addresses',
    title: '收件人管理',
    customNav: true,
    component(resolve) {
      require.ensure(['./components/addresses.vue'], function (require) {
        const component = require('./components/addresses.vue');
        resolve(component);
      }, 'addresses')
    }
  },
  'addresses/select/:id': {
    name: 'selectAddress',
    title: '选择收件人',
    customNav: true,
    component(resolve) {
      require.ensure(['./components/addresses.vue'], function (require) {
        const component = require('./components/addresses.vue');
        resolve(component);
      }, 'addresses')
    }
  },
  'products/:category/:category_name/:brand/:brand_name': {
    name: 'products',
    title: '商品列表',
    component(resolve) {
      require.ensure(['./components/products.vue'], function (require) {
        const component = require('./components/products.vue');
        resolve(component);
      }, 'products')
    }
  },

  'products/:spu/:spu_name': {
    name: 'productsBySpu',
    title: '商品',
    component(resolve) {
      require.ensure(['./components/products.vue'], function (require) {
        const component = require('./components/products.vue');
        resolve(component);
      }, 'productsBySpu')
    }
  },

  seckills: {
    name: 'seckills',
    title: '秒杀列表',
    component(resolve) {
      require.ensure(['./components/seckills.vue'], function (require) {
        const component = require('./components/seckills.vue');
        resolve(component);
      }, 'seckills')
    }
  }, 404: {
    name: '404',
    component(resolve) {
      require.ensure(['./components/404.vue'], function (require) {
        const component = require('./components/404.vue');
        resolve(component);
      }, '404')
    }
  },
  mine: {
    name: 'mine',
    component(resolve) {
      require.ensure(['./components/mine.vue'], function (require) {
        const component = require('./components/mine.vue');
        resolve(component);
      }, 'mine')
    }
  },
  orders: {
    name: 'orders',
    title: '我的订单',
    component(resolve) {
      require.ensure(['./screens/OrdersScreen.vue'], function (require) {
        const component = require('./screens/OrdersScreen.vue');
        resolve(component);
      }, 'orders')
    }
  },
  'order/:order_id': {
    name: 'order',
    title: '订单详情',
    component(resolve) {
      require.ensure(['./screens/OrderDetailScreen.vue'], function (require) {
        const component = require('./screens/OrderDetailScreen.vue');
        resolve(component);
      }, 'order')
    }
  },
  'order/success/:order_id': {
    name: 'paySuccess',
    title: '支付成功',
    component(resolve) {
      require.ensure(['./screens/PaySuccessScreen.vue'], function (require) {
        const component = require('./screens/PaySuccessScreen.vue');
        resolve(component);
      }, 'paySuccess')
    }
  },

  'cart': {
    name: 'cart',
    title: '购物车',
    customNav: true,
    component(resolve) {
      require.ensure(['./screens/CartScreen.vue'], function (require) {
        const component = require('./screens/CartScreen.vue');
        resolve(component);
      }, 'cart')
    }
  },

  'cartAgain/:skus': {
    name: 'cartAgain',
    title: '购物车',
    customNav: true,
    component(resolve) {
      require.ensure(['./screens/CartScreen.vue'], function (require) {
        const component = require('./screens/CartScreen.vue');
        resolve(component);
      }, 'cartAgain')
    }
  },

  coupons: {
    name: 'coupons',
    title: '优惠券',
    component(resolve) {
      require.ensure(['./components/coupons.vue'], function (require) {
        const component = require('./components/coupons.vue');
        resolve(component);
      }, 'coupons')
    }
  },

  couponsTabs: {
    name: 'couponsTabs',
    title: '优惠券',
    component(resolve) {
      require.ensure(['./components/couponsTabs.vue'], function (require) {
        const component = require('./components/couponsTabs.vue');
        resolve(component);
      }, 'couponsTabs')
    }
  },

  'coupons/select/:id': {
    name: 'selectCoupon',
    title: '选择优惠券',
    component(resolve) {
      require.ensure(['./components/coupons.vue'], function (require) {
        const component = require('./components/coupons.vue');
        resolve(component);
      }, 'coupons')
    }
  },

  service: {
    name: 'service',
    title: '',
    component: require('./components/service.vue')
  },

  rebate: {
    name: 'rebate',
    title: '返现列表',
    component(resolve) {
      require.ensure(['./components/rebate.vue'], function (require) {
        const component = require('./components/rebate.vue');
        resolve(component);
      }, 'rebate')
    }
  }, 404: {
    name: '404',
    component(resolve) {
      require.ensure(['./components/404.vue'], function (require) {
        const component = require('./components/404.vue');
        resolve(component);
      }, '404')
    }
  },

  freeDeliver: {
    name: 'freeDeliver',
    title: '包邮列表',
    component(resolve) {
      require.ensure(['./components/freeDeliver.vue'], function (require) {
        const component = require('./components/freeDeliver.vue');
        resolve(component);
      }, 'freeDeliver')
    }
  },

  salePromotion: {
    name: 'salePromotion',
    title: '特卖列表',
    component(resolve) {
      require.ensure(['./components/salePromotion.vue'], function (require) {
        const component = require('./components/salePromotion.vue');
        resolve(component);
      }, 'salePromotion')
    }
  },

  hotGoods: {
    name: 'hotGoods',
    title: '热卖列表',
    component(resolve) {
      require.ensure(['./components/hotGoods.vue'], function (require) {
        const component = require('./components/hotGoods.vue');
        resolve(component);
      }, 'hotGoods')
    }
  },

  noviciate: {
    name: 'noviciate',
    title: '新手列表',
    component(resolve) {
      require.ensure(['./components/noviciate.vue'], function (require) {
        const component = require('./components/noviciate.vue');
        resolve(component);
      }, 'noviciate')
    }
  },

  'order/comments/:order_id': {
    name: 'writeComments',
    title: '写好评',
    component(resolve) {
      require.ensure(['./screens/WriteCommentListScreen.vue'], function (require) {
        const component = require('./screens/WriteCommentListScreen.vue');
        resolve(component);
      }, 'writeComments')
    }
  },

  'order/feedback/:order_id': {
    name: 'feedback',
    title: '意见反馈',
    component(resolve) {
      require.ensure(['./screens/FackbackScreen.vue'], function (require) {
        const component = require('./screens/FackbackScreen.vue');
        resolve(component);
      }, 'feedback')
    }
  },

  'order/comment/:order_id/:sku_id/:spu_id/:img': {
    name: 'writeComment',
    title: '写好评',
    component(resolve) {
      require.ensure(['./screens/WriteCommentScreen.vue'], function (require) {
        const component = require('./screens/WriteCommentScreen.vue');
        resolve(component);
      }, 'writeComment')
    }
  },

});

router.redirect({
  '/': 'home'
});

/**
 * 微信阅读原文Bug
 */
router.redirect({
  '/rd': 'home'
});


router.redirect({
  '*': 'home'
});

router.beforeEach(function (transition) {

  wx.init(); //重置微信分享

  document.title = transition.to.title || '纹身大咖';

  positionCache[transition.from.path] = window.scrollY > 0 ? window.scrollY : 0;

  if (refreshCache[transition.to.name]) {
    transition.to.params.refresh = true;
    delete  refreshCache[transition.to.name];
  }

  // console.log(transition);

  transition.next();
});



// WEBPACK FOOTER //
// ./src/router.js